import PageGlobals from '@aytm/app/stats/lib/page/page-globals'

export const FORBIDDEN_CODEBOOK_SYMBOLS = '":;<>'
export const FORBIDDEN_TAG_SYMBOLS = '";<>'

export const DEFAULT_SELECTED_ACTION = 'skipper'
export const DEFAULT_SELECTED_CODEBOOK = '*'

export const STORAGE_KEY = `${PageGlobals.SURVEY_ID}${PageGlobals.USER_ID || 0}-codebooks`
